import {closestCenter, DndContext, PointerSensor, useSensor, useSensors} from "@dnd-kit/core";
import {arrayMove, SortableContext} from "@dnd-kit/sortable";
import React from "react";

export const DNDSortableContext = ({items, setItems, children}) => {
    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: {distance: 5}
    }));

    const onDragEnd = (event) => {
        const {active: dragged, over: displaced} = event;

        if (dragged.id !== displaced.id) {
            setItems((prevState) => {
                const prevIndex = prevState.findIndex((colour) => colour.id === dragged.id);
                const newIndex = prevState.findIndex((colour) => colour.id === displaced.id);
                // @ts-ignore
                return arrayMove(prevState, prevIndex, newIndex).map((item, index) => ({...item, position: index}));
            })
        }
    }

    return (<DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={onDragEnd}
    >
        <SortableContext items={items.map(selectedColour => selectedColour.id)}
        >
            {children}
        </SortableContext>
    </DndContext>)
}